import { editorPicks } from '@/mocks/home';

export default function EditorPicks() {
  return (
    <section id="picks" className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-8 md:px-8 md:py-10">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div className="flex items-center gap-2">
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50 dark:text-foreground-950">
              <i className="ri-quill-pen-line" />
            </span>
            <div>
              <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">值班编辑精选</h2>
              <p className="mt-1 text-sm text-foreground-600">不比谁发得快，只讲这条信息该怎么看、哪里还站不住。</p>
            </div>
          </div>
          <span className="flex h-8 items-center gap-2 self-start rounded-full border border-background-200 bg-background-50 px-3 font-label text-xs text-foreground-600 md:self-auto">
            <i className="ri-team-line" />
            三位编辑轮值
          </span>
        </div>

        <div className="mt-5 grid grid-cols-1 gap-4 md:grid-cols-3">
          {editorPicks.map((pick) => (
            <article
              key={pick.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-background-300"
            >
              <div className="h-40 w-full overflow-hidden">
                <img
                  src={pick.image}
                  alt={`${pick.title} 配图`}
                  title="黑料六点 值班编辑精选"
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.04]"
                />
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <span className="flex h-6 w-fit items-center rounded-md bg-accent-100 px-2 font-label text-[11px] font-medium text-accent-700">
                  {pick.tag}
                </span>
                <h3 className="mt-3 font-heading text-base font-bold leading-snug text-foreground-950">{pick.title}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{pick.excerpt}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                  <span className="font-label text-xs text-foreground-600">{pick.author}</span>
                  <span className="font-label text-xs tabular-nums text-foreground-500">{pick.time}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}